<template>
  <div class="CommentTab">
    <form class="" data-form="comment">
      <textarea v-model="comment" placeholder="Add your comment here..."></textarea>
    </form>
    <div class="form-comment-slide-btns" v-if="comment.length">
      <button class="btn lead-view-comment-post" @click="send">
        <span v-if="!isLoading && !isSuccess">Post</span>
        <span v-else-if="isLoading">{{ translates.loading }}</span>
        <span v-else-if="isSuccess" class="successful">{{ translates.successful }}</span>
      </button>
      <button class="btn lead-view-comment-cancel" @click="cancel"><span>Cancel</span></button>
    </div>
  </div>
</template>

<script>
import LeadDataService from '../../../services/lead-data.service'
import {front} from "../../../lang/en";

export default {
  name: "CommentTab",
  data() {
    return {
      translates: front,
      comment: '',
      isLoading: false,
      isSuccess: false,
    }
  },
  computed: {
    Timetable: {
      get() {
        return this.$store.state.timetable;
      },
      set(value) {
        this.$store.commit('setter', {timetable: value})
      }
    },
    Lead: {
      get() {
        return this.$store.state.leadData;
      },
      set(value) {
        this.$store.commit('setter', {leadData: value})
      }
    },
  },
  methods: {
    cancel() {
      this.comment = '';
      this.isSuccess = false;
      this.isLoading = false;
    },
    send() {
      this.isLoading = true;
      let lead = this.Lead;
      let query = {
        id: this.Lead.info.id,
        userid: this.Lead.userId,
        comment: this.comment
      }
      this.Timetable = null;

      LeadDataService.addComment(query).then((res) => {
        if (res.data.result) {
          this.isLoading = false;
          this.isSuccess = true;
          let item = res.data.timetable[0] ?? null;
          if (item) {
            lead.timetable.unshift(item);
            this.Lead = lead;
          }

          setTimeout(() => {
            this.isSuccess = false;
            this.comment = '';
          }, 1000);
        }
      })
    }
  }
}
</script>

<style lang="scss">
.CommentTab {
  .form-comment-slide-btns {
    display: block !important;
  }

  span.successful {
    color: #05a205;
  }
}
</style>
